/** Инструменты панели (расширяется по одному). */
export const BOARD_TOOL_IDS = [
  "select",
  "hand",
  "pen",
  "line",
  "arrow",
  "shape",
  "frame",
  "text",
  "sticky",
  "eraser",
] as const;

export type BoardToolId = (typeof BOARD_TOOL_IDS)[number];

export function isBoardToolId(value: string): value is BoardToolId {
  return (BOARD_TOOL_IDS as readonly string[]).includes(value);
}

export type BoardToolDef = {
  id: BoardToolId;
  title: string;
  shortcut?: string;
  enabled: boolean;
};
